import common from "@page/common/js/common";
// import corpPage from '@global/components/global/staticInfoPage';
var Path = require("@global/vendors/path");

import siteCtrl from "@page/common/js/siteCtrl";

siteCtrl.corpPage();

// corpPage();

// $(".about-content").hide();

// hash listen
function pathStart(n) {
	Path.pathjs.map("#" + n).to(function () {
		$(".about-content").hide();
		$("#corp-content-" + n).fadeIn("slow");
		console.log($("#corp-content-" + n));
	});
}

for (var i = 0; i < $("#about-list>li").length; i++) {
	pathStart(i);
}
Path.pathjs.root("#0");

Path.pathjs.listen();
